import { createAction } from 'typesafe-actions';
import { IPhenology } from '../../../types/model/masterData/phenology';
import { IPhenologyAssignment } from '../../../types/model/phenology/assignment';

export default class PhenologyActions {
    public static setLoading = createAction('PHYNOLOGY_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('PHYNOLOGY_SET', resolve => (list : Array<IPhenology>) => resolve(list));
    public static setLoadingAssignments = createAction('PHYNOLOGY_ASSIGNMENTS_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setAssignments = createAction('PHYNOLOGY_ASSIGNMENTS_SET', resolve => (list : Array<IPhenologyAssignment>) => resolve(list));
}